/*******************************************************************************
ACTIVATE JUMP BAR
Removes tabs that are associated with section IDs that do not exist and un-hide the bar.
*******************************************************************************/

// This checks if the sections exist for each tab
function checkTabs($jumpBar) {
    $jumpBar.find('.jump-link').each((index, tab) => {
        const $tab = $(tab);
        const id = $tab.attr('href');
        if ($(id).length === 0) { $tab.remove(); }
    });
    $jumpBar.removeClass('hide');
}

export default function activateJumpBar() {
    $('.jump-bar').each((i, jumpBar) => {
        const $jumpBar = $(jumpBar);

        // This is an event to wait for before checking the tabs
        const waitFor = $jumpBar.data('waitFor');
        const extraWaitTime = $jumpBar.data('extraTime');

        if (waitFor) {
            $(document).on(waitFor, () => {
                if (extraWaitTime) {
                    setTimeout(() => { checkTabs($jumpBar); }, extraWaitTime);
                }
                else {
                    checkTabs($jumpBar);
                }
            });
        }
        else {
            checkTabs($jumpBar);
        }
    });
}
